import { InputLabel, TextField } from "@mui/material";
import styled from "styled-components";

export const StyledLabel = styled(InputLabel)`

    white-space: nowrap !important;
    font-size: 0.9rem !important;
    padding: 2px 10px 2px 2px !important;
    overflow: visible !important;
    color: rgba(0, 0, 0, 0.7) ;

`
export const StyledTextField = styled(TextField)`

.MuiInputBase-input{
    font-size: 0.9rem;
}

`
export const StyledDiv = styled('div')`



`
